// @ts-nocheck
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Card, Tabs, Tab, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import GeneralConfiguration from './GeneralConfiguration';
import ModelConfiguration from './ModelConfiguration';

// ----------------------------------------------------------------------

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

// ----------------------------------------------------------------------

export default function Settings() {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Settings | Knowledge AI</title>
      </Helmet>

      <Container>
        <Typography variant="h4" mb={3} mt={4} sx={{ color: theme.palette.mode === 'dark' ? '#C7C9C7' : '#333f48' }}>
          Settings
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="General Configuration" />
            <Tab label="Model Configuration" />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <GeneralConfiguration />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <ModelConfiguration />
        </TabPanel>
      </Container>
    </>
  );
}
